"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormModel2 = _interopRequireDefault(require("./FormModel"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _mobx = require("mobx");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// e.g. FormModelFactory.form(props)
//          .withValidations({
//              state: validations.isRequired("state"),
//              country: validations.isRequired("country"),
//          })
//          .withSelectOptions(["stateSelect", "countrySelect"])
//          .create();
// these functions will be wrapped to return a chainable context
var FormModelFactory = {
  form: function form(props, formContext) {
    props = (0, _isEmpty.default)(props) ? {
      data: {}
    } : props;
    formContext.formProps = props;
  },
  storageProvider: function storageProvider(_storageProvider, formContext) {
    formContext.storageProvider = _storageProvider;
  },
  withValidations: function withValidations(validationsObject, formContext) {
    formContext.validations = validationsObject;
  },
  withValidationSteps: function withValidationSteps(validationStepsObject, formContext) {
    formContext.validationSteps = validationStepsObject;
  },
  withMessageContainerId: function withMessageContainerId(messageContainerId, formContext) {
    formContext.messageContainerId = messageContainerId;
  },
  withPassThroughProps: function withPassThroughProps(propList, formContext) {
    formContext.passThroughProps = propList;
  },
  withParent: function withParent(parentForm, formContext) {
    formContext.formProps = (0, _extend.default)(formContext.formProps, {
      parent: parentForm
    });
  },
  withDirtyTracking: function withDirtyTracking(formContext) {
    formContext.enableDirtyTracking = true;
  }
}; // Wrap all of the validations so that they are chainable.

var wrapFunction = function wrapFunction(chainableFn) {
  return function () {
    var context = (0, _extend.default)({
      __factoryContext: true,
      fn: chainableFn,
      args: arguments
    }, FormModelFactory);

    if (this.__factoryContext) {
      this.next = context;
      context.root = this.root;
    } else {
      context.root = context;
    }

    return context;
  };
}; // do the wrapping


(0, _forEach.default)(Object.keys(FormModelFactory), function (key) {
  FormModelFactory[key] = wrapFunction(FormModelFactory[key]);
}); // And add the create() method to finish the chain into a FormModel class

FormModelFactory.create = function () {
  if (!this.__factoryContext) {
    throw new Error("Invalid FormModelFactory chain");
  }

  var formContext = {};
  var next = this.root;

  while (next) {
    var _next;

    // call everything in the chain with formContext
    var args = [].concat(Array.prototype.slice.apply(next.args)).concat([formContext]);

    (_next = next).fn.apply(_next, _toConsumableArray(args));

    next = next.next;
  }

  var FormModelChild = /*#__PURE__*/function (_FormModel) {
    _inherits(FormModelChild, _FormModel);

    var _super = _createSuper(FormModelChild);

    function FormModelChild(props, storageProvider) {
      var _this;

      _classCallCheck(this, FormModelChild);

      _this = _super.call(this, props, storageProvider, FormModelChild.validations());

      if (formContext.passThroughProps) {
        (0, _mobx.extendObservable)(_assertThisInitialized(_this), (0, _pick.default)(props, formContext.passThroughProps));
      }

      if (formContext.enableDirtyTracking) {
        _this.setOriginalData();
      }

      if (formContext.messageContainerId) {
        _this.messageContainerId = formContext.messageContainerId;
      }

      return _this;
    }

    _createClass(FormModelChild, [{
      key: "validationSteps",
      get: function get() {
        if (formContext.validationSteps) {
          return formContext.validationSteps;
        }

        return _get(_getPrototypeOf(FormModelChild.prototype), "validationSteps", this);
      }
    }], [{
      key: "validations",
      value: function validations() {
        return formContext.validations ? formContext.validations : {};
      }
    }]);

    return FormModelChild;
  }(_FormModel2.default);

  return new FormModelChild(formContext.formProps, formContext.storageProvider);
};

var _default = FormModelFactory;
exports.default = _default;